import { cn } from "@/lib/utils";

/** Languette discrète sur le bord droit de la sidebar (desktop). */
export default function SidebarCollapseTab({ collapsed, onToggle, testId = "sidebar-collapse-tab" }) {
  if (!onToggle) return null;

  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={collapsed ? "Déplier le menu" : "Réduire le menu"}
      aria-expanded={!collapsed}
      data-testid={testId}
      className={cn(
        "absolute top-1/2 right-0 z-40 hidden -translate-y-1/2 translate-x-[calc(100%-1px)] lg:block",
        "h-24 w-[14px]",
        "rounded-r-lg border border-[#2D7FF9] border-l-[#2569e8] bg-[#2D7FF9]",
        "shadow-[2px_0_10px_rgba(45,127,249,0.35)] transition-[background,box-shadow] duration-150",
        "hover:bg-[#1f6fe8] hover:border-[#1f6fe8] hover:shadow-[2px_0_12px_rgba(45,127,249,0.45)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[#2D7FF9]",
      )}
    />
  );
}
